import React from 'react';

import styles from './styles.module.css';

interface GridContainerProps {
  children: React.ReactNode;
  minItemWidth?: string;
  gap?: string;
  align?: 'left' | 'center' | 'right' | 'none';
  independentHeight?: boolean;
  className?: string;
  columns?: number;
  gridTemplateColumns?: string;
}

const GridContainer: React.FC<GridContainerProps> = ({
  children,
  minItemWidth = 'auto',
  gap = '30px',
  align = 'center',
  independentHeight = false,
  className = '',
  columns,
  gridTemplateColumns
}) => {
  const getJustifyContent = () => {
    switch (align) {
      case 'left':
        return 'flex-start';
      case 'right':
        return 'flex-end';
      case 'center':
      default:
        return 'center';
    }
  };

  const getGridTemplateColumns = () => {
    if (gridTemplateColumns) {
      return gridTemplateColumns;
    }
    if (columns !== undefined) {
      return `repeat(${columns}, 1fr)`;
    }
  };

  return (
    <div className={styles.gridContainerWrapper}>
      <div
        className={`${styles.gridContainer} ${independentHeight ? styles.independentHeight : ''} ${className}`}
        style={
          {
            '--min-item-width': minItemWidth,
            '--grid-gap': gap,
            '--grid-template-columns': getGridTemplateColumns(),
            ...(align !== 'none' && { justifyContent: getJustifyContent() })
          } as React.CSSProperties
        }
      >
        {children}
      </div>
    </div>
  );
};

export default GridContainer;
